// extracted by mini-css-extract-plugin
export default {"container":"arrowButton_container__C2w16","button":"arrowButton_button__TsqHC","active":"arrowButton_active__vzYob"};